import React from 'react';
import styles from './FileViewContainer.module.scss';
import downloadVoiting from '../../../../../../Voting/containers/voting-item/components/SaveVoiting/downloadVoiting';
import { Divider, Icon } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';
import CustomPopconfirm from '../CustomPopconfirm/CustomPopconfirm';
import useDeleteRSODraft from '../../../../../mutations/useDeleteRSODraft';
import {
  setClearAllState,
  setGetFileRso,
} from '../../../store/actions/rsoImportActions';
import { queryClient } from '../../../../../../../queryClient';
import { getQueryKeys } from '../../../../../queries/queryKeys';
import moment from 'moment';

const ActionClickBox = ({ type = 'check', onClick, text }) => {
  return (
    <div className={styles.containerActionsClick}>
      <div
        style={{ backgroundColor: '#e6f2ff' }}
        className={cn(styles.circleBox, styles.actionClick)}
        onClick={onClick}
      >
        <Icon
          style={{ color: '#0995ED', fontSize: '20px' }}
          type={type}
        />
      </div>
      <div
        onClick={onClick}
        className={styles.textAction}
      >
        {text}
      </div>
    </div>
  );
};

const FileViewContainer = () => {
  const { getFileRso, valueForm } = useSelector(
    (state) => state.rsoImportStore
  );

  const { deleteRso, loading: loadingDeleteRso } = useDeleteRSODraft({
    draftId: valueForm?.id,
  });

  const dispatch = useDispatch();

  const onClickClose = () => {
    queryClient.setQueryData(getQueryKeys.rsoDraft(), null);
    dispatch(setClearAllState());
  };

  const onClickDelete = async () => {
    await deleteRso(valueForm?.id);
    dispatch(setClearAllState());
  };

  const onClickGoBack = () => {
    queryClient.setQueryData(getQueryKeys.rsoDraft(), null);
    dispatch(setGetFileRso(null));
  };

  const onDownloadFile = () => {
    downloadVoiting(getFileRso?.generatedData, getFileRso?.generatedFileName);
  };

  return (
    <div className={styles.conteinerFile}>
      <div className={styles.upContainer}>
        <div
          className={styles.circleBox}
          style={{ backgroundColor: '#E9F5E9' }}
        >
          <Icon
            style={{ color: '#17B032', fontSize: '20px' }}
            type="check"
          />
        </div>
        <div className={styles.textFile}>
          Файл отчета РСО доступен для загрузки
        </div>
        <div className={styles.nameFile}>
          {getFileRso?.generatedFileName} от{' '}
          {moment(valueForm?.generatedDate).format('DD.MM.YYYY')} (файл будет
          удален {moment(valueForm?.deletedDate).format('DD.MM.YYYY')} в{' '}
          {moment(valueForm?.deletedDate).format('HH:mm')})
        </div>
        <div
          className={styles.btn}
          onClick={onDownloadFile}
        >
          Скачать файл
          <Icon
            style={{ color: '#0995ED', fontSize: '16px' }}
            type="download"
          />
        </div>
      </div>
      <Divider style={{ margin: 0 }} />
      <div className={styles.downContainer}>
        <div className={styles.actionTitle}>Действия</div>
        <div className={styles.containerBoxs}>
          <ActionClickBox
            type="plus-circle"
            onClick={onClickClose}
            text="Создать новый отчет"
          />
          <ActionClickBox
            type="edit"
            onClick={onClickGoBack}
            text="Редактировать отчет"
          />
          <CustomPopconfirm
            okText="Да"
            cancelText="Нет"
            title="Вы действительно желаете удалить файл из памяти?"
            onConfirm={onClickDelete}
            placement="top"
          >
            <div className={styles.containerActionsClick}>
              <div
                style={{ backgroundColor: '#e6f2ff' }}
                className={cn(styles.circleBox, styles.actionClick)}
              >
                {loadingDeleteRso ? (
                  <Icon type="loading" />
                ) : (
                  <Icon
                    style={{ color: '#0995ED', fontSize: '20px' }}
                    type="delete"
                  />
                )}
              </div>
              <div className={styles.textAction}>Удалить отчет</div>
            </div>
          </CustomPopconfirm>
        </div>
      </div>
    </div>
  );
};

export default FileViewContainer;
